'use client'

import { motion } from 'framer-motion'

export function PhaseFullStack() {
  return (
    <section id="full-stack" className="pb-16 md:pb-24 scroll-mt-16">
      <div className="container max-w-7xl mx-auto px-6">
        <div className="backdrop-blur-2xl bg-white/[0.03] border border-[#3e4658] rounded-[40px] lg:rounded-[60px] p-8 md:p-12 lg:p-16">
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                className="text-[#61d8fe] text-lg font-anuphan mb-4"
              >
                Phase 3 — Starting at $10,000
              </motion.p>
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-white text-3xl md:text-[48px] font-normal leading-[1.1] font-gendy mb-6"
              >
                The Full Stack
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="text-white text-xl md:text-[26px] leading-[1.4] font-anuphan mb-4"
              >
                Build + Learn. The complete package.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.15 }}
                className="text-[#bdbdbd] text-lg font-anuphan leading-relaxed mb-4"
              >
                Why choose between having us build your AI systems and learning to build them yourself? The Full Stack combines both — we deploy high-impact workflows and agents for you while teaching you to master, maintain, and extend them through one-on-one training.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="text-[#8a8f9e] text-sm font-anuphan italic mb-8"
              >
                Bundled discount for clients who want both execution and mastery. Scope and pricing tailored to your needs.
              </motion.p>
              <a
                href="https://calendly.com/alex-behmn/discovery-call"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#544ae8] border border-[#475065] rounded-[100px] px-10 py-4 text-white text-lg font-anuphan hover:scale-[1.02] active:scale-[0.98] transition-transform"
              >
                Get the Full Stack
              </a>
            </div>

            <div className="space-y-4">
              {[
                {
                  title: 'Custom Build + Deploy',
                  desc: 'We architect and deploy workflows, AI agents, and automations directly into your operations — the same caliber as our standalone Build engagements.',
                },
                {
                  title: 'One-on-One Training',
                  desc: 'Personalized masterclass sessions that teach you how to use, maintain, and extend everything we build. You\u2019re never dependent on us.',
                },
                {
                  title: 'Bundled Value',
                  desc: 'Combined pricing that\u2019s more efficient than engaging Build and Academy separately. One relationship, one timeline, maximum impact.',
                },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="bg-white/[0.03] border border-[#3e4658] rounded-[16px] p-5 hover:border-[#61d8fe]/20 transition-colors"
                >
                  <p className="text-white font-semibold font-anuphan mb-1">{item.title}</p>
                  <p className="text-[#8a8f9e] text-sm font-anuphan">{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
